export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/d50cc34e778c6c20c755dccf4a153599.svg";